// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8 4H16V1H18V4H22V9H2V4H6V1H8V4Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 11.0037V22H2V11.0037H22ZM11.2572 19.9068L16.9141 14.2499L15.4999 12.8357L11.2572 17.0783L9.13589 14.957L7.72168 16.3712L11.2572 19.9068Z"}}]};

const Calendar2FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'calendar-2-filled',
    ref,
    icon: element,
  },
));

Calendar2FilledIcon.displayName = 'Calendar2FilledIcon';

export default Calendar2FilledIcon;
